const env: any = {
  production: false,
  apiUrl: 'http://localhost:1337',
  baseUrl: 'https://app-cosimapgame-dev.azurewebsites.net',
};

env.baseApiUrl = `${env.baseUrl}/api`;

export const environment = env;
